import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AppService } from '@data/app/app.service';
import { AuthService } from '@data/auth/auth.service';
import { BehaviorSubject, Subject, distinctUntilChanged, map, takeUntil } from 'rxjs';
import packageInfo from '../../package.json';

@Component({
  selector: 'la-self-service-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {

  private _componentDestroyed$ = new Subject<boolean>;

  public isWideScreen$ = new BehaviorSubject(false);
  public packageVersion: string;

  constructor(
    appService: AppService,
    _authService: AuthService,
    _breakpointObserver: BreakpointObserver,
    _meta: Meta,
  ) {
    _authService.setCookie();

    _breakpointObserver
      .observe([Breakpoints.Handset, Breakpoints.TabletPortrait])
      .pipe(
        takeUntil(this._componentDestroyed$),
        distinctUntilChanged(),
        map( matches => !matches.matches )
      )
      .subscribe( isWideScreen => {
        appService.isWideScreen$.next(isWideScreen);
        this.isWideScreen$.next(isWideScreen);
      });

    this.packageVersion = packageInfo.appRelease || '';
    _meta.addTag({
      name: 'version',
      content: this.packageVersion
    });
  }

  ngOnDestroy(): void {
    this._componentDestroyed$.next(true);
    this._componentDestroyed$.complete();
  }
}
